<template>
  <div
    class="html_playerTable_combatADT_infor"
    ref="html_playerTable_combatADT_infor"
    v-if="datas.objectInfo && datas.objectInfo.length > 0"
  >
    <div
      class="main"
      :class="[
        datas.objectInfo && datas.objectInfo.length === 2 ? 'doublePlayer' : '',
      ]"
    >
      <div
        class="singlePlayer"
        v-for="(singleItem, itemIndex) in datas.objectInfo"
        :key="itemIndex"
      >
        <div class="left-box">
          <AbPlayerImg
            v-for="item in singleItem.playerInfos"
            :width="
              datas.objectInfo && datas.objectInfo.length === 2
                ? 'calc(6.64vw * var(--mixtmt_mixvw))'
                : 'calc(7.64vw * var(--mixtmt_mixvw))'
            "
            :key="item.playerId"
            :playerImg="item.profilePicture"
            :playerNum="item.shirtNumber"
            :playerName="`${item.playerName} ${
              item.position ? '(' + item.position + ')' : ''
            }`"
            :playerLogoSize="playerLogoSize"
            :countryImg="
              singleItem.teamLogo
                ? singleItem.teamLogo
                : singleItem.playerInfos[0].countryLogo
            "
            :countryName="
              singleItem.teamName
                ? singleItem.teamName
                : singleItem.playerInfos[0].countryName
            "
            :countryLogoSize="countryLogoSize"
          ></AbPlayerImg>
        </div>
        <div class="right-box" v-if="tableData && tableData.length > 0">
          <div
            class="items"
            v-for="(item, textIndex) in tableData[itemIndex]"
            :key="textIndex"
            v-text="_valFormatHandler(item)"
          ></div>
        </div>
      </div>
      <!-- <div class="singlePlayer">
        <div class="left-box" v-if="datas.objectInfo[0].playerInfos">
          <AbPlayerImg
            v-for="item in datas.objectInfo[0].playerInfos"
            :key="item.playerId"
            :playerImg="item.profilePicture"
            :playerNum="item.shirtNumber"
            :playerName="`${item.playerName} ${
              item.position ? '(' + item.position + ')' : ''
            }`"
            :countryImg="datas.objectInfo[0].teamLogo"
            :countryName="datas.objectInfo[0].teamName"
            :countryLogoSize="countryLogoSize"
          ></AbPlayerImg>
        </div>
        <div
          class="right-box"
          v-if="datas.statisticsModels && datas.statisticsModels.length > 0"
        >
          <div
            class="items"
            v-for="item in datas.statisticsModels"
            :key="item.statisticalEn"
            v-text="
              _valFormatHandler(
                tableData[item.statisticalEn],
                item.name,
                item.suffix
              )
            "
          ></div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// 测试id目前是5
// 对抗类信息对比 单人【A队头像+A队表格信息】 双人【A队表格信息+A队头像+B队头像+B队表格信息】支持ADT三种，目前只有AD
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg.vue'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_playerTable_combatADT_infor',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    AbPlayerImg,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    countryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        if (this.datas.objectInfo.length === 2) {
          return [
            'calc(1.666vw * var(--mixtmt_mixvw))',
            'calc(1.666vw * var(--mixtmt_mixvw))',
          ]
        } else {
          return [
            'calc(1.666vw * var(--mixtmt_mixvw))',
            'calc(1.666vw * var(--mixtmt_mixvw))',
          ]
        }
      } else {
        if (this.datas.objectInfo.length === 2) {
          return [
            'calc(1.874vw * var(--mixtmt_mixvw))',
            'calc(1.25vw * var(--mixtmt_mixvw))',
          ]
        } else {
          return [
            'calc(2.498vw * var(--mixtmt_mixvw))',
            'calc(1.666vw * var(--mixtmt_mixvw))',
          ]
        }
      }
    },
    playerLogoSize() {
      if (this.datas.objectInfo.length === 2) {
        return [
          'calc(4.8vw * var(--mixtmt_mixvw))',
          'calc(6.398vw * var(--mixtmt_mixvw))',
        ]
      } else {
        return [
          'calc(6.25vw * var(--mixtmt_mixvw))',
          'calc(8.33vw * var(--mixtmt_mixvw))',
        ]
      }
    },
    tableData() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList
        : []
    },
  },
  methods: {
    _valFormatHandler(val) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        data = val
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_playerTable_combatADT_infor {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);
    &.doublePlayer {
      width: 98%;
      .singlePlayer {
        &:first-child {
          flex-direction: row-reverse;
          .right-box {
            margin: 0 0.278vw 0 0;
          }
        }
        .right-box {
          margin: 0 0 0 0.278vw;
        }
      }
    }
    .singlePlayer {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }
    .left-box {
      font-size: 0.972vw;
    }
    .right-box {
      margin: 0 0 0 0.694vw;
      height: auto;
      max-height: 16.25vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      overflow: auto;
      .items {
        width: 100%;
        line-height: 1.388vw;
        padding: 0.278vw 0.694vw;
        color: var(--mixtmt_greyColor_main);
        text-align: center;
        &:nth-child(2n-1) {
          background-color: var(--mixtmt_subColor_main05);
        }
      }
    }
  }
  .ptb4 {
    padding: 0.278vw 0;
  }
}
</style>
